export default class BlockSliderSimple {
	constructor() {

		let blocks = document.querySelectorAll('.block-text-slider');

		blocks.forEach((block) => {
			const swiper = block.querySelector('.swiper');
			const prev = block.querySelector(".navigation-button-prev");
			const next = block.querySelector(".navigation-button-next");
			const navigation = block.querySelector('.swiper-navigation');
			new Swiper(swiper, {
				slidesPerView: 1,
				grabCursor: true,
				navigation: {
					prevEl: prev,
					nextEl: next,
				},
				pagination: {
					el: navigation,
					type: 'bullets',
					bulletElement: 'span',
					clickable: true
				}
			});
		});
	}
}
